<template>
  <div class="prize" :class="{ inApp: $root.$data.isApp || $root.miniprogram }">
    <common-title titleName="活动奖品" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="prize-content">
      <img
        class="cardprizeImg"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/cardprizeImg.png"
        alt=""
      />
      <img
        class="cardprizetips"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/cardprizetips.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  computed: {},
  created() {},

  mounted() {
    document.title = '活动奖品';
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.prize {
  padding-top: 100px;
  &.inApp {
    padding-top: 0px;
  }
  .prize-content {
    padding-top: 1px;
    min-height: 100vh;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/cardprizebg.png')
      no-repeat center;
    background-size: 100% 100%;

    img {
      display: block;
      margin: 0 auto;
    }
    .cardprizeImg {
      width: 630px;
      margin-top: 50px;
      margin-bottom: 120px;
    }
    .cardprizetips {
      width: 633px;
      padding-bottom: 40px;
    }
  }
}
</style>
